import { submitEnquiry, determineEnquiryType } from '~/services/enquiry';

export default defineNuxtPlugin((nuxtApp) => {
  // Make the service available globally through the Nuxt app
  nuxtApp.provide('enquiry', {
    submitEnquiry,
    determineEnquiryType
  });
});
